import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
  >
    <path
      className="stroke-change"
      fill="none"
      fillRule="evenodd"
      stroke="#9F9F9F"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M10 22l14-12 14 12v16H27v-8h-6v8H10z"
    />
  </svg>
);
